export const LogoMark = ({ className = "w-8 h-8" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" rx="16" fill="#A8DCF2" />
    <path d="M18 12h28v34H18z" fill="#fff" fillOpacity=".6" />
    <path d="M14 50h36" stroke="#0B1120" strokeWidth="4" strokeLinecap="round" />
    <path d="M32 18l3.6 7.6 8.2.9-6.1 5.6 1.7 8.1L32 36l-7.4 4.2 1.7-8.1-6.1-5.6 8.2-.9z" fill="#0B1120" />
  </svg>
);

export const Logo = ({ dark = false, testid = "nav-logo" }) => (
  <a href="#top" data-testid={testid} className="flex items-center gap-2.5 group">
    <LogoMark className="w-8 h-8 transition-transform duration-500 group-hover:rotate-[-8deg]" />
    <span className={`font-display italic font-black text-2xl tracking-tight ${dark ? "text-[#A8DCF2]" : "text-[#5FB4E2]"}`}>
      EasyREW<span className={dark ? "text-white" : "text-[#0B1120]"}>.</span>
    </span>
  </a>
);
